import { createUseQueryHook } from 'hooks/createUseQueryHook';

export const useAvailableGroups = createUseQueryHook('get_available_groups');
